import { all, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { convertToFundingSearch } from './types';

const logger = new Logger('Saga:FundingReport convert to FundingSearch');

export function* requestConvertToFundingSearchSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { reportId } = action;

  try {
    yield call(
      authApiService.post,
      routerService.generate('api.funding_report_convert', { reportId }),
    );

    action.promise && action.promise.resolve();
  } catch (error) {
    logger.error('Failed to convert to funding report with the following error', error);
    action.promise && action.promise.reject(error);
  }
}

export default function* convertToFundingSearchSaga() {
  return yield all([takeLatest(convertToFundingSearch.request, requestConvertToFundingSearchSaga)]);
}
